<template>
  <div class="entry">
    <van-button
      type="info"
      size="large"
      color="#cccccc"
      :style="{ 'margin-bottom': '20px'  }"
      @click="to(item.transportType)"
      v-for="(item, index) in total"
      :key="index"
      >{{ item.transportType }}({{ item.waitPickNum || 0 }})</van-button
    >
  </div>
</template>

<script>
import { Icon, Toast, Button } from "vant";
import { getPickCount } from "@/api/mobile/picking_api.js";

export default {
  data() {
    return {
      total: {},
    };
  },

  components: {
    [Icon.name]: Icon,
    [Toast.name]: Toast,
    [Button.name]: Button,
  },

  created() {
    this.getPickTotal();
  },

  computed: {},

  methods: {
    to(type) {
      this.$router.push({ path: "/mobile/picking", query: { type } });
    },

    getPickTotal() {
      const _warehouse = JSON.parse(window.localStorage.warehouse);

      const data = {
        warehouseId: _warehouse.warehouseId,
      };

      getPickCount(data).then((res) => {
        if (res.status === 200 && res.success) {
          this.total = res.response;
        } else {
          Toast.fail(res.msg);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.entry {
  padding: 30% 10%;
  box-sizing: border-box;
}
::v-deep .van-button__content {
  color: #5f5f5f;
}
</style>